module.exports = __webpack_public_path__ + "img/icon7.ea46d04a.png";